import React from 'react'
import useRouteGuard from '../hooks/useRouteGuard'
import Loading from './Loading'
import { Box, Alert, AlertTitle, Typography } from '@mui/material'
import { Block as BlockIcon } from '@mui/icons-material'

interface RouteGuardProps {
  allowedPermissions: string[]
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const RouteGuard: React.FC<RouteGuardProps> = ({
  allowedPermissions,
  children,
  fallback = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        p: 4,
      }}
    >
      <Alert
        severity="error"
        sx={{
          maxWidth: 500,
          '& .MuiAlert-icon': {
            fontSize: '2rem',
          },
        }}
      >
        <AlertTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <BlockIcon />
            Access Denied
          </Box>
        </AlertTitle>
        <Typography variant="body1" sx={{ mb: 1 }}>
          You don't have permission to access this page.
        </Typography>
      </Alert>
    </Box>
  ),
}) => {
  const { hasAccess, isLoading } = useRouteGuard(allowedPermissions)

  if (isLoading) {
    return <Loading />
  }

  // no access message
  if (!hasAccess) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
